var _style, _g, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Eye_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Eye_svg__st1{fill:currentColor}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eye_svg__Stroke",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Eye_svg__Stroke-Copy",
    d: "M30 0c16.6 0 30 13.4 30 30S46.6 60 30 60 0 46.6 0 30 13.4 0 30 0z",
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Eye_svg__st1",
    d: "M53.4 31.3c-.4-.5-9.7-11.8-21.4-11.8S11 30.8 10.6 31.3l-.5.7.6.7c.3.5 9.6 11.8 21.3 11.8s21-11.3 21.4-11.8l.6-.7-.6-.7zM32 42.2c-9 0-16.8-7.8-19-10.2 2.2-2.4 9.9-10.2 19-10.2S48.8 29.6 51 32c-2.2 2.4-10 10.2-19 10.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Eye_svg__st1",
    d: "M32 23.4c-4.8 0-8.6 3.9-8.6 8.6s3.9 8.6 8.6 8.6 8.6-3.9 8.6-8.6-3.8-8.6-8.6-8.6zm0 15c-3.5 0-6.4-2.8-6.4-6.4s2.8-6.4 6.4-6.4 6.4 2.8 6.4 6.4-2.9 6.4-6.4 6.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Eye_svg__st1",
    d: "M32 28.9c-1.8 0-3.1 1.5-3.1 3.1 0 1.8 1.5 3.1 3.1 3.1 1.8 0 3.1-1.5 3.1-3.1 0-1.8-1.3-3.1-3.1-3.1zm0 4c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9z"
  })));
};
export default SvgEye;